import { extractResponseError } from "./extract";

export const createFetch = (): typeof fetch => {
  return async (input, init) => {
    try {
      // Ensure credentials are included for authentication
      const response = await fetch(input, {
        ...init,
        credentials: "include", // Include cookies for authentication
      });
      if (!response.ok) {
        throw await response.json();
      }
      return response;
    } catch (error) {
      throw extractResponseError(error);
    }
  };
};
